const textFieldFormEquip = {
  serialNumber: 'Numero de serie',
  brand: 'Marca del equipo',
  name: 'Especificaciones del equipo',
  reference: 'Punto de referencia',
  amount: 'Valor',
  acquisitionDate: 'Fecha de adquisición',
  residualValue: 'Valor Residual',
};

export default textFieldFormEquip;

